
export default () => ({
	data: null,
	department: {},
	currencies: [],
	plans: [],
	params: [],
	meta: {},
	loading: {
		departments: false,
		partnerships: false,
		vacation: false
	},
	searchFilters: {},
	partnerships: [],
	countries: null,
	vacation: null,
	lastVacation: null
})
